module.exports = __webpack_public_path__ + "img/pie.be5030ca.webp";